import { useSelector } from 'react-redux';
import FJDisplayHeader from './FJDisplayHeader';
import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useDispatch } from 'react-redux';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJConstant from '../../../constants/FJConstant';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJCommonRightHeaderContainer from './FJCommonRightHeaderContainer.jsx';
import FJGenerateStatus from '../../../common/components/FJGenerateStatus/FJGenerateStatus.jsx';
import FJDropDownManager from '../../../common/js/FJDropDownManager.js';

const FJDisplayHeaderContainer = props => {
    const {
        hasEditImage = false,
        rightChildren,
        isHideBottomLine = false,
        className,
        hideCancelButton = false,
    } = props;

    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const progress = useSelector(state => state.common.progress);
    const currentQueue = useSelector(state => state.common.currentQueue);
    const queueNumber = useSelector(state => state.common.queueNumber);
    const appType = useSelector(state => state.common.appType);

    const taskStatus = useSelector(state => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            return state.aiPhotoEditor.taskStatus;
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            return state.textToImage.taskStatus;
        } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            return state.imageToImage.taskStatus;
        } else {
            return state.common.taskStatus;
        }
    });

    // TODO 不同的ai工具的特殊判断
    const isShowPresetImageBox = useSelector(state => state.textToImage.isShowPresetImageBox);

    const setSliceCreationShowTab = useCallback(
        value => {
            dispatch(FJActionCommon.setHeaderTabIndexAction(value));
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
            FJDropDownManager.hideAll();
        },
        [dispatch],
    );

    const onCancel = useCallback(() => {
        dispatch(FJActionCommon.cancelTaskAction());
    }, [dispatch]);

    const showStatus = useMemo(() => {
        // 以下几个工具没有状态显示
        if (
            appType === FJAppConstant.IMAGE_ENHANCER ||
            appType === FJAppConstant.FAKE_3D ||
            appType === FJAppConstant.PHOTO_REMOVE_BG ||
            appType === FJAppConstant.AI_VIDEO_GENERATOR ||
            appType === FJAppConstant.VIDEO_REMOVE_BG ||
            appType === FJAppConstant.AI_VIDEO_DUB ||
            appType === FJAppConstant.TEXT_TO_IMAGE ||
            appType === FJAppConstant.IMAGE_TO_IMAGE ||
            appType === FJAppConstant.AI_PHOTO_EDITOR
        ) {
            return false;
        } else if (appType === FJAppConstant.IMAGE_EXTENDER) {
            return taskStatus !== FJConstant.DEFAULT && headerTabIndex !== FJConstant.CREATIONS;
        }

        return taskStatus !== FJConstant.DEFAULT;
    }, [headerTabIndex, taskStatus, appType]);

    // 是否显示需要编辑的canvas
    const isShowEditCanvas = useMemo(() => {
        return (
            (taskStatus === FJConstant.DEFAULT || taskStatus === FJConstant.SUCCESS) &&
            hasEditImage &&
            headerTabIndex === FJConstant.CREATIONS
        );
    }, [hasEditImage, taskStatus, headerTabIndex]);

    // 右侧区域容器不设置 padding 的场景 需要内侧添加 padding
    const isPreDomNotPaddingBox = useMemo(() => {
        const appList = [
            // FJAppConstant.IMAGE_EXTENDER,
            // FJAppConstant.OBJECT_ERASER,
            // FJAppConstant.PHOTO_RESTORATION,
            // FJAppConstant.PHOTO_COLORIZE,
            FJAppConstant.PHOTO_REMOVE_BG,
        ];

        if (appList.includes(appType) && headerTabIndex === FJConstant.CREATIONS) {
            return true;
        }

        return false;
    }, [headerTabIndex, appType]);

    const hideBottomLine = useMemo(() => {
        if (
            appType === FJAppConstant.PHOTO_REMOVE_BG ||
            appType === FJAppConstant.OBJECT_ERASER ||
            appType === FJAppConstant.PHOTO_RESTORATION ||
            appType === FJAppConstant.PHOTO_COLORIZE
        )
            return false;

        if (isHideBottomLine && headerTabIndex === FJConstant.CREATIONS) {
            return true;
        }

        return isShowEditCanvas;
    }, [headerTabIndex, isShowEditCanvas, isHideBottomLine, appType]);

    const _rightChildren = () => {
        if (showStatus)
            return (
                <FJGenerateStatus
                    taskStatus={taskStatus}
                    onCancel={hideCancelButton ? null : onCancel}
                    progress={progress}
                    currentQueue={currentQueue}
                    queueNumber={queueNumber}
                />
            );
        else if (rightChildren) {
            return rightChildren;
        }

        if (appType === FJAppConstant.TEXT_TO_IMAGE && isShowPresetImageBox) {
            return null;
        }
        const showIndex = appType === FJAppConstant.IMAGE_EXTENDER ? FJConstant.GENERATIONS : FJConstant.CREATIONS;
        return (
            ((window.isEditPage &&
                appType !== FJAppConstant.VIDEO_REMOVE_BG &&
                appType !== FJAppConstant.AI_VIDEO_GENERATOR &&
                appType !== FJAppConstant.AI_PHOTO_EDITOR) ||
                appType === FJAppConstant.AI_VIDEO_DUB) &&
            headerTabIndex === showIndex && <FJCommonRightHeaderContainer />
        );
    };

    return (
        <FJDisplayHeader
            appType={appType}
            selectedIndex={headerTabIndex}
            onTabChange={setSliceCreationShowTab}
            rightChildren={_rightChildren()}
            hideBottomLine={hideBottomLine}
            isPreDomNotPaddingBox={isPreDomNotPaddingBox}
            className={className}
        />
    );
};

FJDisplayHeaderContainer.propTypes = {
    hasEditImage: PropTypes.bool,
    rightChildren: PropTypes.node,
    isHideBottomLine: PropTypes.bool,
    hideCancelButton: PropTypes.bool,
    className: PropTypes.string,
};

export default FJDisplayHeaderContainer;
